<div class="myslides">
    <div class="ombre"></div>
    <swiper [config]="options">
        <div class="swiper-wrapper">
            <div *ngFor="let image of images;let i=index" class="swiper-slide" [ngStyle]="{'background': 'url('+image+')','background-position':'center','background-size':'cover'}">
            </div>
        </div>
        <div class="swiper-pagination"></div>
    </swiper>
    <div class="slider-description" #description>
        <img class="logo" src="assets/images/logos/logo.png" alt="logo">
        <div class="rowb">
            <div class="col-6">
                <a routerLink="/carte" class="add-to-cart btn">
                    <i class="flaticon-shopping"></i>
                    <span>Commander</span>
                </a>
            </div>
            <!-- <div class="col-6">
                <a href="https://www.burgerbynight16.fr/" target="_blank" class="add-to-cart btn">
                    <i class="flaticon-shopping"></i>
                    <span>Une faim de nuit ?</span>
                </a>
            </div> -->
        </div>
    
        <div class="gradient-border" id="box" *ngIf="enablePayement">
            <img src="assets/images/payamenet2.png" alt="Paiement par carte bancaire">
        </div>
    </div>
</div>